export enum InviteLinkType {
  Unique = 'unique',
  Public = 'public',
}
